// extracted by mini-css-extract-plugin
module.exports = {"pageNF":"Applications_pageNF__3jCDe","spinner":"Applications_spinner__iw41X","chart":"Applications_chart__1Lt4q","clickablelink":"Applications_clickablelink__3Jk8p"};